import React, { useEffect, useRef, useState } from 'react'
import NumberFormat from 'react-number-format'
import { Button, Card, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, PopoverBody, PopoverHeader, Row, Table, UncontrolledPopover } from 'reactstrap'
import Recargos from '../CotizacionPymes/Recargos'
import styles from '../TablaCoberturasIndividual/styles'
import { obtenerColor } from '../../utils/validaciones'

const ComponentCoberturasParametrico = ({
    guardarInformacion,
    onRegresar,
    planSeleccionado,
    setPlanSeleccionado,
    planes,
    coberturas,
    datosCarrito,
    amparos,
    aplicaRecargos,
    aplicaObservaciones,
    mensajeRecargos,
    requiereRecargos,
    setRequiereRecargos,
    recargoSeleccionado,
    setRecargoSeleccionado,
    recargos,
    recargoModificado,
    setRecargoModificado,
    recalcularCoberturas,
    mensajeObservaciones,
    requiereObservacion,
    setRequiereObservacion,
    observacion,
    setObservacion,
    productos
}) => {



    const [valorAsegurado, setValorAsegurado] = useState(0.00)
    const [valorAseguradoExtras, setValorAseguradoExtras] = useState(0)
    const [valorAseguradoMasExtras, setValorAseguradoMasExtras] = useState(0)
    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [popover, setPopover] = useState(
        {
            titulo: '',
            descripcion: ''
        }
    )

    const totalProductos = productos.length;
    const esImpar = totalProductos % 2 !== 0;

    const div3Ref = useRef(null);
    const div4Ref = useRef(null);



    useEffect(() => {

        if (datosCarrito && datosCarrito.carValorAsegurado) {
            setValorAsegurado(parseFloat(datosCarrito.carValorAsegurado))

            var valorEncontrado = null

            if (datosCarrito.carPreguntas) {
                datosCarrito.carPreguntas.forEach(categoria => {

                    const valorEncontradoPreguntas = categoria.preguntas.find(v => v.cuesCodigocobertura == 'valoraseguradoextras')

                    if (valorEncontradoPreguntas) {
                        setValorAseguradoExtras(parseFloat(valorEncontradoPreguntas.value ? valorEncontradoPreguntas.value : 0))
                        const value = parseFloat(valorEncontradoPreguntas.value ? parseFloat(valorEncontradoPreguntas.value) + parseFloat(valorAsegurado) : valorAsegurado)
                        setValorAseguradoMasExtras(value)
                    }




                });
            }


        }

        if (div4Ref && div4Ref.current) {
            const div1Height = div4Ref.current.offsetHeight;
            div3Ref.current.style.height = `${div1Height}px`;
        }



    }, [datosCarrito])




    /**
     * Obtener el siguiente o anterior elemento de la lista de planes para mostrar los valores correspondientes
     * @param {*} paso siguiente o anterior
     */
    const obtenerSiguienteElemento = (paso) => {

        const indiceActual = planes.indexOf(planSeleccionado)

        const primerIndice = 0;
        const ultimoIndice = planes.length - 1
        const previous = indiceActual == primerIndice ? planes[ultimoIndice] : planes[indiceActual - 1];

        const next = indiceActual == ultimoIndice ? planes[primerIndice] : planes[indiceActual + 1];


        if (paso == 'siguiente') {
            setPlanSeleccionado(next)
        } else {
            setPlanSeleccionado(previous)
        }

    }

    function Cobertura({ cobertura }) {
        const div1Ref = useRef(null);
        const div2Ref = useRef(null);

        useEffect(() => {
            const div1Height = div1Ref.current.offsetHeight;
            div2Ref.current.style.height = `${div1Height}px`;
        }, []);

        let value;

        switch (cobertura.cobValor) {

            case 'valorasegurado':
                value = valorAsegurado;
                break;
            case 'valoraseguradomasextras':
                value = valorAseguradoMasExtras;
                break;
            case 'valoraseguradoextras':
                value = valorAseguradoExtras;
                break;
            default:
                value = cobertura.cobValor;
                break;
        }


        return (
            <Row style={{ width: '100%' }}>

                <Col xs={6} style={{ textAlign: 'center' }}>
                    <div ref={div1Ref}
                        style={{
                            backgroundColor: "white",
                            maarginRight: 'auto',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '40px',
                            padding: '15px',
                            flexGrow: 1,
                            marginLeft: '15px'

                        }}>
                        <p style={{ textAlign: "center", fontSize: 13 }} >
                            {cobertura.cobNombre}
                        </p>
                    </div>
                </Col>
                <Col xs={6} style={{ textAlign: 'center' }}>
                    <div ref={div2Ref}
                        style={{
                            backgroundColor: "white",
                            marginLeft: 'auto',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '40px',
                            padding: '15px',
                            flexGrow: 1

                        }}>
                        <p style={{ textAlign: "center", fontSize: 13 }} >
                            <NumberFormat
                                value={(value)}
                                className="foo"
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalScale={2}
                                fixedDecimalScale={2}
                                decimalSeparator={','}
                                prefix={'$'}
                                renderText={(value, props) => <div {...props}><p>{value}</p></div>}
                            />
                        </p>
                    </div>
                </Col>
            </Row>
        )
    }

    return (
        <Row>
            <Col
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="div-align-center"
            >
                <Card>
                    <CardBody>
                        <h4 style={{ fontWeight: 'bold' }}>




                        </h4>


                        <Row>

                            {productos && productos.length > 0 && productos.map((producto, index) => {

                                const esUltimo = index === totalProductos - 1;

                                return (
                                    <Col   md={6} className={esImpar ? 'offset-md-3' : ''} >
                                        <div style={{ backgroundColor: '#F8F9FA' }}>
                                            <div style={{ backgroundColor: obtenerColor(index), color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '85px', padding: '15px', textAlign: 'center' }}>
                                                {producto.prodNombre.toUpperCase()}
                                            </div>


                                            {
                                                planSeleccionado && coberturas.filter(cobertura => cobertura.catProdCodigo == producto.catProdCodigo).map((cobertura, index) => {

                                                    let value;

                                                    switch (cobertura.cobValor) {

                                                        case 'valorasegurado':
                                                            value = valorAsegurado;
                                                            break;
                                                        case 'valoraseguradomasextras':
                                                            value = valorAseguradoMasExtras;
                                                            break;
                                                        case 'valoraseguradoextras':
                                                            value = valorAseguradoExtras;
                                                            break;
                                                        default:
                                                            value = cobertura.cobValor;
                                                            break;
                                                    }

                                                    return (
                                                        <Cobertura cobertura={cobertura} />
                                                    )
                                                })
                                            }

                                            {producto.prodLabel && producto.prodLabel != '' &&
                                                <Row>

                                                    <Col xs={12} style={{ textAlign: 'center' }}>
                                                        <div style={{ backgroundColor: "white", display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40px' }}>
                                                            <small>  {producto.prodLabel}</small>
                                                        </div>
                                                    </Col>


                                                </Row>
                                            }

                                            {
                                                esUltimo &&
                                                <React.Fragment>

                                                    <Row style={{ width: '100%' }}>

                                                        <Col xs={6} style={{ textAlign: 'center' }}>
                                                            <div
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    maarginRight: 'auto',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    minHeight: '40px',
                                                                    padding: '15px',
                                                                    flexGrow: 1,
                                                                    marginLeft: '15px'

                                                                }}>
                                                                <p style={{ backgroundColor: "white", width: '320px', color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40px' }}>
                                                                    PRIMA NETA
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} style={{ textAlign: 'center' }}>
                                                            <div
                                                                style={{
                                                                    backgroundColor: "#af006e",
                                                                    marginLeft: 'auto',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    minHeight: '40px',
                                                                    padding: '15px',
                                                                    flexGrow: 1

                                                                }}>
                                                                <p style={{ textAlign: "center", fontSize: 23 }} >
                                                                    <div style={{ color: 'white',  }}>
                                                                        {'$' + parseFloat(planSeleccionado ? planSeleccionado.primaneta : '0').toFixed(2)}
                                                                    </div>
                                                                </p>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    {amparos &&

                                                        <Row style={{ width: '100%' }}>

                                                            <Col xs={6} style={{ textAlign: 'center' }}>
                                                                <div
                                                                    style={{
                                                                        maarginRight: 'auto',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        minHeight: '40px',
                                                                        padding: '15px',
                                                                        flexGrow: 1,
                                                                        marginLeft: '15px'

                                                                    }}>
                                                                    <p style={{  width: '320px', color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40px' }}>
                                                                    
                                                                    </p>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} style={{ textAlign: 'center' }}>
                                                                <div
                                                                    style={{
                                                                        marginLeft: 'auto',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        minHeight: '40px',
                                                                        padding: '15px',
                                                                        flexGrow: 1

                                                                    }}>
                                                                    <p style={{ textAlign: "center", fontSize: 23 }} >
                                                                        <div style={{  width: '180px', marginLeft: 'auto', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40px' }}>
                                                                            <button className="div-align-center btn btn-detail-white  " style={{ width: '360px', backgroundColor: "#F0F0EB" }} onClick={() => setPopoverOpen(true)}>
                                                                                <p style={{ textAlign: "center", fontSize: 18 }} >
                                                                                    <i
                                                                                        className="fa fa-info-circle"
                                                                                        aria-hidden="true"
                                                                                    />{" "}

                                                                                    Ver Detalles
                                                                                </p>
                                                                            </button>
                                                                        </div>
                                                                    </p>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                      
                                                    }


                                                  



                                                </React.Fragment>
                                            }



                                        </div>


                                    </Col>
                                )
                            })}


                        </Row>











                    </CardBody>

                </Card>
            </Col>

            {(aplicaRecargos) &&
                <Col
                    lg={8}
                    md={12}
                    sm={12}
                    xs={12}
                    className="div-align-center"
                >
                    <Recargos
                        aplicaObservaciones={false}
                        aplicaRecargos={aplicaRecargos}
                        mensajeRecargos={mensajeRecargos}
                        requiereRecargos={requiereRecargos}
                        setRequiereRecargos={(valor) => { setRequiereRecargos(valor) }}
                        recargoSeleccionado={recargoSeleccionado}
                        setRecargoSeleccionado={(valor) => { setRecargoSeleccionado(valor) }}
                        recargos={recargos}
                        recargoModificado={recargoModificado}
                        setRecargoModificado={(value) => { setRecargoModificado(value) }}
                        recalcularCoberturas={() => { recalcularCoberturas() }}
                        mensajeObservaciones={mensajeObservaciones}
                        requiereObservacion={requiereObservacion}
                        setRequiereObservacion={(valor) => { setRequiereObservacion(valor) }}
                        observacion={observacion}
                        setObservacion={(value) => { setObservacion(value) }}

                    />

                </Col>

            }



            <Col
                lg={8}
                md={12}
                sm={12}
                xs={12}
                className="div-align-center"
            >
                <Row>
                    <Col style={{ textAlign: 'right' }}>
                        <Button
                            className="btn btn-detail-gray"
                            style={{ margin: "auto" }}
                            onClick={() => onRegresar()}
                        >
                            <i class="fa fa-chevron-circle-left" aria-hidden="true" />
                            &nbsp;REGRESAR
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            className={recargoModificado ? "btn btn-primary btn-purple fe-pulse" : "btn btn-primary"}
                            style={{ display: "block", marginRight: "5px" }}
                            onClick={() => {

                                if (recargoModificado) {
                                    recalcularCoberturas()

                                } else {
                                    guardarInformacion({ planSeleccionado: planSeleccionado, coberturas: coberturas, requiereRecargos: requiereRecargos, recargo: requiereRecargos ? recargoSeleccionado : null })
                                }

                            }}
                        >
                            <i
                                className="fa fa-chevron-circle-right"
                                aria-hidden="true"
                            />{" "}
                            {recargoModificado ? "Actualizar" : "CONTINUAR"}
                        </Button>
                    </Col>
                </Row>


            </Col>


            <Modal
                isOpen={popoverOpen}
                toggle={() => setPopoverOpen(!popoverOpen)}
                size="lg"
            >

                <ModalBody>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: amparos,
                        }}
                    />

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setPopoverOpen(false)}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </Row>



    )

}

export default ComponentCoberturasParametrico